exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submission-box>.el-dialog>.el-dialog__header{-webkit-box-shadow:none;box-shadow:none;padding-bottom:0;padding:0}.submission-box>.el-dialog>.el-dialog__header>.el-dialog__headerbtn{position:absolute;top:0;right:0;padding:0;background:#1e1d1d;border:none;outline:none;cursor:pointer;font-size:24px;font-weight:700;z-index:10}.submission-box>.el-dialog{top:8vh;max-width:1300px;background-color:#f4f5f7}.ck .ck-balloon-panel{z-index:9999!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-422f96c5","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/SubmissionPage.vue
// module id = Top/
// module chunks = 0